import { render, staticRenderFns } from "./default.vue?vue&type=template&id=021a5096&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./default.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('/app/components/layout/header.vue').default,LayoutFooter: require('/app/components/layout/footer.vue').default,ConsentBar: require('/app/components/consent-bar.vue').default})
